module.exports = __webpack_public_path__ + "img/canvas-morning-normal.9a08ebfc.jpg";